export const styles = {
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  closeContainer: {
    display: 'flex',
    justifyContent: 'end',
    padding: '20px 20px 0 20px',
  },
  closeButton: {
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontFamily: 'Proxima Nova, sans-serif',
    fontWeight: 700,
    fontSize: '24px',
  },
  formContainer: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
  },
  flex: {
    width: '100%',
    display: 'flex',
  },
  ml10: {
    marginLeft: '10px',
  },
  required: {
    color: 'red',
  },
  selectOptions: {
    maxHeight: '330px',
  },
  uploadWarn: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    marginBottom: '10px',
  },
  uploadWrapper: {
    height: '170px',
    width: '100%',
    border: `2px dashed #4F5B94`,
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  upload: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploaded: {
    width: '100%',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > svg': {
      cursor: 'pointer',
      width: '20px',
    },
    '& > p': {
      fontSize: '16px',
      fontFamily: 'Proxima Nova, sans-serif',
    },
  },
  uploadTitle: {
    marginTop: '10px',
  },
  uploadMessage: {
    color: '#798498',
    fontSize: '12px',
  },
  fileValidationError: {
    marginTop: '10px',
    fontSize: '14px',
    color: 'red',
    textAlign: 'center',
  },
  downloadTemplateWrapper: {
    background: '#F9F9FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '13px',
    marginTop: '10px',
    fontFamily: 'Proxima Nova, sans-serif',
  },
  downloadTemplateTitle: {
    fontSize: '14px',
    fontWeight: 700,
    fontFamily: 'Proxima Nova, sans-serif',
  },
  downloadTemplateBody: {
    fontSize: '14px',
    fontFamily: 'Proxima Nova, sans-serif',
  },
}
